/* eslint-disable */
import { useState, useEffect } from "react";
import ArticleList from "../components/admin/ArticleList";
import { Article, Author, Category, KeywordData, Product } from "../types/type";
import axios from "axios";
import { Link } from "react-router-dom";

const AdminPage = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [authors, setAuthors] = useState<Author[]>([]);
  const [keywords, setKeywords] = useState<KeywordData[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [newCategory, setNewCategory] = useState<Category>({
    id: undefined,
    name: "",
    koreaName: "",
    var: "",
    numOfArticles: 0,
  });
  const [newAuthor, setNewAuthor] = useState<Author>({
    id: undefined,
    authorName: "",
    authorEmail: "",
    authorInsta: "",
    authorLinkedin: "",
  });
  const [newProduct, setNewProduct] = useState<Product>({
    id: undefined,
    name: "",
    imageUrl: "",
    numOfArticles: 0,
  });

  const [newKeyword, setNewKeyword] = useState<KeywordData>({
    id: undefined,
    categoryId: undefined,
    categoryKorName: undefined,
    categoryName: undefined,
    name: "",
    numOfArticles: 0,
    koreaName: "",
    desc: "",
    studyLink: [],
  });

  useEffect(() => {
    fetch("/api/articles")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch articles");
        }
        return response.json();
      })
      .then((data) => {
        // 데이터가 배열인지 확인
        if (Array.isArray(data)) {
          setArticles(data);
        } else {
          throw new Error("Invalid data format");
        }
      })
      .catch((error) => console.error("Error:", error));

    const fetchCategoriesAndKeywordsAndProducts = async () => {
      try {
        const [catResponse, keywordResponse, productsResponse, authorResponse] =
          await Promise.all([
            axios.get("/api/categories"),
            axios.get("/api/keywords"),
            axios.get("/api/products"),
            axios.get("/api/author"),
          ]);
        setCategories(catResponse.data);
        setKeywords(keywordResponse.data);
        setProducts(productsResponse.data);
        setAuthors(authorResponse.data);
      } catch (error) {
        console.error(
          "Failed to fetch categories and keywords and products:",
          error,
        );
      }
    };

    fetchCategoriesAndKeywordsAndProducts();
  }, []);

  const handleDeleteArticle = (id: string) => {
    fetch(`/api/articles/${id}`, { method: "DELETE" })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete article");
        }
        setArticles(articles.filter((article) => article.id !== id));
      })
      .catch((error) => console.error("Error:", error));
  };

  const handleCategoryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewCategory((prev) => ({ ...prev, [name]: value }));
  };
  const handleAuthorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewAuthor((prev) => ({ ...prev, [name]: value }));
  };
  const handleProductChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewProduct((prev) => ({ ...prev, [name]: value }));
  };
  const handleKeywordChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setNewKeyword((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddCategory = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      newCategory.var = newCategory.name
        ?.toUpperCase()
        // @ts-ignore
        .replaceAll(" ", "")
        .replaceAll("'", "");

      const response = await axios.post("/api/categories", newCategory);
      setCategories((prev) => [...prev, response.data]);
      setNewCategory({
        id: undefined,
        name: "",
        koreaName: "",
        var: "",
        numOfArticles: 0,
      });
    } catch (error) {
      console.error("Failed to add category:", error);
    }
  };

  const handleAddAuthor = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await axios.post("/api/author", newAuthor);
      setAuthors((prev) => [...prev, response.data]);
      setNewAuthor({
        id: undefined,
        authorName: "",
        authorEmail: "",
        authorInsta: "",
        authorLinkedin: "",
      });
    } catch (error) {
      console.error("Failed to add author:", error);
    }
  };

  const handleAddProduct = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await axios.post("/api/products", newProduct);
      setProducts((prev) => [...prev, response.data]);
      setNewProduct({
        id: undefined,
        name: "",
        imageUrl: "",
        numOfArticles: 0,
      });
    } catch (error) {
      console.error("Failed to add category:", error);
    }
  };

  const [studyLinks, setStudyLinks] = useState<string[]>([""]);

  const handleAddKeyword = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      console.log({
        ...newKeyword,
        studyLink: studyLinks,
      });
      const response = await axios.post("/api/keywords", {
        ...newKeyword,
        studyLink: studyLinks,
      });
      setKeywords((prev) => [...prev, response.data]);
      setNewKeyword({
        id: undefined,
        categoryId: undefined,
        categoryKorName: undefined,
        categoryName: undefined,
        name: "",
        numOfArticles: 0,
        koreaName: "",
        desc: "",
        studyLink: [],
      });
      setStudyLinks([]);
    } catch (error) {
      console.error("Failed to add keyword:", error);
    }
  };

  const handleStudyLinkChange = (index: number, value: string) => {
    const updatedLinks = [...studyLinks];
    updatedLinks[index] = value;
    setStudyLinks(updatedLinks);
  };

  const handleAddStudyLink = () => {
    setStudyLinks((prev) => [...prev, ""]); // 새로운 텍스트 영역 추가
  };

  const [editingCategoryId, setEditingCategoryId] = useState<string | null>(
    null,
  ); // 수정 중인 카테고리 ID
  const [editingCategory, setEditingCategory] = useState<Category | null>(null); // 수정 중인 카테고리 데이터

  const handleEditCategory = (category: Category) => {
    setEditingCategoryId(category.id || null);
    setEditingCategory({ ...category });
  };

  const handleCancelEditCategory = () => {
    setEditingCategoryId(null);
    setEditingCategory(null);
  };

  const handleEditingCategoryChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (!editingCategory) return;
    const { name, value } = e.target;
    setEditingCategory((prev) => (prev ? { ...prev, [name]: value } : null));
  };

  const handleUpdateCategory = async () => {
    if (!editingCategory || !editingCategoryId) return;

    try {
      const response = await axios.put(
        `/api/categories/${editingCategoryId}`,
        editingCategory,
      );

      setCategories((prev) =>
        prev.map((cat) => (cat.id === editingCategoryId ? response.data : cat)),
      );

      setEditingCategoryId(null);
      setEditingCategory(null);
    } catch (error) {
      console.error("Failed to update category:", error);
    }
  };

  const [editingKeywordId, setEditingKeywordId] = useState<string | null>(null); // 수정 중인 키워드 ID
  const [editingKeyword, setEditingKeyword] = useState<KeywordData | null>(
    null,
  ); // 수정 중인 키워드 데이터

  const handleEditKeyword = (keyword: KeywordData) => {
    setEditingKeywordId(keyword.id || null);
    setEditingKeyword({ ...keyword });
  };

  const handleCancelEditKeyword = () => {
    setEditingKeywordId(null);
    setEditingKeyword(null);
  };

  const handleEditingKeywordChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    if (!editingKeyword) return;
    const { name, value } = e.target;
    setEditingKeyword((prev) => (prev ? { ...prev, [name]: value } : null));
  };

  const handleEditStudyLinkChange = (index: number, value: string) => {
    setEditingKeyword((prev) => {
      const updatedLinks = [...(prev?.studyLink || [])];
      updatedLinks[index] = value;
      return { ...prev, studyLink: updatedLinks };
    });
  };

  const handleEditRemoveStudyLink = (index: number) => {
    setEditingKeyword((prev) => {
      const updatedLinks = [...(prev?.studyLink || [])];
      updatedLinks.splice(index, 1);
      return { ...prev, studyLink: updatedLinks };
    });
  };

  const handleEditAddStudyLink = () => {
    setEditingKeyword((prev) => ({
      ...prev,
      studyLink: [...(prev?.studyLink || []), ""],
    }));
  };

  const handleUpdateKeyword = async () => {
    if (!editingKeyword || !editingKeywordId) return;

    try {
      const response = await axios.put(
        `/api/keywords/${editingKeywordId}`,
        editingKeyword,
      );

      setKeywords((prev) =>
        prev.map((keyword) =>
          keyword.id === editingKeywordId ? response.data : keyword,
        ),
      );

      setEditingKeywordId(null);
      setEditingKeyword(null);
    } catch (error) {
      console.error("Failed to update keyword:", error);
    }
  };

  const handleDeleteCategory = async (id: string | undefined) => {
    try {
      await axios.delete(`/api/categories/${id}`);

      setCategories((prev) => prev.filter((cat) => cat.id !== id));
    } catch (error) {
      console.error("Failed to delete category:", error);
    }
  };
  const handleDeleteProduct = async (id: string | undefined) => {
    try {
      await axios.delete(`/api/products/${id}`);

      setProducts((prev) => prev.filter((cat) => cat.id !== id));
    } catch (error) {
      console.error("Failed to delete category:", error);
    }
  };
  const handleDeleteKeyword = async (id: string | undefined) => {
    try {
      await axios.delete(`/api/keywords/${id}`);
      setKeywords((prev) => prev.filter((keyword) => keyword.id !== id));
    } catch (error) {
      console.error("Failed to delete keyword:", error);
    }
  };

  return (
    <div className="admin-page">
      <div className="article-title-wrapper">
        <div className="title">현재 게시글 리스트</div>
        <Link className="add-column-btn" to={"/admin/post"}>
          게시물 추가하러가기
        </Link>
      </div>
      <ArticleList articles={articles} onDeleteArticle={handleDeleteArticle} />

      {/* Add Category Form */}
      <h2>Add Category</h2>
      <form onSubmit={handleAddCategory}>
        <label>
          Name:
          <input
            type="text"
            name="name"
            value={newCategory.name}
            onChange={handleCategoryChange}
            required
          />
        </label>
        <label>
          Korean Name:
          <input
            type="text"
            name="koreaName"
            value={newCategory.koreaName}
            onChange={handleCategoryChange}
          />
        </label>
        <button type="submit">Add Category</button>
      </form>

      {/* Add Author Form */}
      <h2>Add Author</h2>
      <form onSubmit={handleAddAuthor}>
        <label>
          Name:
          <input
            type="text"
            name="authorName"
            value={newAuthor.authorName}
            onChange={handleAuthorChange}
            required
          />
        </label>
        <label>
          작성자 이메일
          <input
            type="text"
            name="authorEmail"
            value={newAuthor.authorEmail}
            onChange={handleAuthorChange}
          />
        </label>
        <label>
          작성자 인스타그램
          <input
            type="text"
            name="authorInsta"
            value={newAuthor.authorInsta}
            onChange={handleAuthorChange}
          />
        </label>
        <label>
          작성자 링크드인
          <input
            type="text"
            name="authorLinkedin"
            value={newAuthor.authorLinkedin}
            onChange={handleAuthorChange}
          />
        </label>
        <button type="submit">Add Author</button>
      </form>

      <h2>Add Product</h2>
      <form onSubmit={handleAddProduct}>
        <label>
          product 이름
          <input
            type="text"
            name="name"
            value={newProduct.name}
            onChange={handleProductChange}
            required
          />
        </label>
        <label>
          product 이미지
          <input
            type="url"
            name="imageUrl"
            value={newProduct.imageUrl}
            onChange={handleProductChange}
            placeholder="이미지 URL"
            required
          />
        </label>
        <button type="submit">Add Product</button>
      </form>

      {/* Add Keyword Form */}
      <h2>Add Keyword</h2>
      <form onSubmit={handleAddKeyword}>
        <label>
          Category:
          <select
            name="category"
            value={newKeyword.categoryName || ""}
            onChange={(e) => {
              const selectedCategory = categories.find(
                (cat) => cat.name === e.target.value,
              );
              setNewKeyword((prev) => ({
                ...prev,
                categoryId: selectedCategory?.id,
                categoryName: selectedCategory?.name,
                categoryKorName: selectedCategory?.koreaName,
              }));
            }}
          >
            <option value="">Select Category</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.name}>
                {cat.name}
              </option>
            ))}
          </select>
        </label>
        <label>
          Name:
          <textarea
            name="name"
            value={newKeyword.name}
            onChange={(e) => handleKeywordChange(e)}
            required
          />
        </label>
        <label>
          Korean Name:
          <textarea
            name="koreaName"
            value={newKeyword.koreaName}
            onChange={(e) => handleKeywordChange(e)}
          />
        </label>
        <label>
          Description:
          <textarea
            name="desc"
            value={newKeyword.desc}
            onChange={(e) => handleKeywordChange(e)}
          />
        </label>
        <label>
          Study Links:
          {studyLinks.map((link, index) => (
            <textarea
              key={index}
              value={link}
              onChange={(e) => handleStudyLinkChange(index, e.target.value)}
            />
          ))}
        </label>
        <button type="button" onClick={handleAddStudyLink}>
          +
        </button>
        <button type="submit">Add Keyword</button>
      </form>

      {/* Category List */}
      <h2>Categories</h2>
      <ul>
        {categories.map((cat) => (
          <li key={cat.id}>
            {editingCategoryId === cat.id ? (
              // 수정 모드
              <div>
                <input
                  type="text"
                  name="name"
                  value={editingCategory?.name || ""}
                  onChange={handleEditingCategoryChange}
                />
                <input
                  type="text"
                  name="koreaName"
                  value={editingCategory?.koreaName || ""}
                  onChange={handleEditingCategoryChange}
                />
                <button onClick={handleUpdateCategory}>확인</button>
                <button onClick={handleCancelEditCategory}>취소</button>
              </div>
            ) : (
              // 기본 보기 모드
              <div>
                이름 : <b>{cat.name}</b> 한국어 이름 : <b>{cat.koreaName}</b>
                <button onClick={() => handleEditCategory(cat)}>수정</button>
                <button onClick={() => handleDeleteCategory(cat.id)}>
                  삭제
                </button>
              </div>
            )}
          </li>
        ))}
      </ul>

      <h2>Products</h2>
      <ul>
        {products.map((pro) => (
          <li key={pro.id}>
            {pro.name}{" "}
            <button onClick={() => handleDeleteProduct(pro.id)}>Delete</button>
          </li>
        ))}
      </ul>

      {/* Keyword List */}
      <h2>Keywords</h2>
      <ul>
        {keywords.map((keyword) => (
          <li key={keyword.id}>
            {editingKeywordId === keyword.id ? (
              // 수정 모드
              <div>
                <div>Category 한국어: {keyword.categoryKorName}</div>
                <textarea
                  name="name"
                  value={editingKeyword?.name || ""}
                  onChange={(e) => handleEditingKeywordChange(e)}
                />
                <textarea
                  name="koreaName"
                  value={editingKeyword?.koreaName || ""}
                  onChange={(e) => handleEditingKeywordChange(e)}
                />
                <textarea
                  name="desc"
                  value={editingKeyword?.desc || ""}
                  onChange={(e) => handleEditingKeywordChange(e)}
                />
                <div>
                  Study Links:
                  {editingKeyword?.studyLink?.map((link, index) => (
                    <div key={index}>
                      <textarea
                        value={link}
                        onChange={(e) =>
                          handleEditStudyLinkChange(index, e.target.value)
                        }
                      />
                      <button
                        type="button"
                        onClick={() => handleEditRemoveStudyLink(index)}
                      >
                        삭제
                      </button>
                    </div>
                  ))}
                  <button type="button" onClick={handleEditAddStudyLink}>
                    + 링크 추가
                  </button>
                </div>
                <button onClick={handleUpdateKeyword}>확인</button>
                <button onClick={handleCancelEditKeyword}>취소</button>
              </div>
            ) : (
              // 기본 보기 모드
              <div>
                카테고리명 : <b>{keyword.categoryKorName}</b> 이름 :{" "}
                <b>{keyword.name}</b> 한국어 이름 : <b>{keyword.koreaName}</b>
                <button onClick={() => handleEditKeyword(keyword)}>수정</button>
                <button onClick={() => handleDeleteKeyword(keyword.id)}>
                  삭제
                </button>
              </div>
            )}
          </li>
        ))}
      </ul>

      <h2>Authors</h2>
      <ul>
        {authors.map((aut) => (
          <li key={aut.id}>
            이름 : <b>{aut.authorName}</b> 이메일 : <b>{aut.authorEmail}</b>{" "}
            인스타 : <b>{aut.authorInsta}</b> 링크드인 :{" "}
            <b>{aut.authorLinkedin}</b>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AdminPage;
